import { PARTNERS } from '../../constants/enums';
import { alkymetricsClient } from '../alkymetricsClient';

export const getLoginNotesInfo = async () => {
  const { data } = await alkymetricsClient.get(`loginNotes/random?platform=${PARTNERS}`);
  return data;
};